import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import WordCloud from "../../../../../src/components/WordCloud";
import namesData from "../../../../../src/data/namesData.ts";
import * as React from 'react';
export default {
  Playground,
  Frame,
  WordCloud,
  namesData,
  React
};